import React from 'react';

import { CalendarIcon, ClockFilledIcon } from '@icons';
import { getStartEndDate } from '@utils/date';

import * as Styled from './promotion-date.styled';

type OwnProps = {
	isActive?: boolean;
	start_date: string;
	end_date: string;
	isSmall?: boolean;
	isEnded?: boolean;
};

const PromotionDate: React.FC<OwnProps> = ({ isActive, isEnded, start_date, end_date, isSmall }) => {
	return (
		<Styled.Wrapper>
			{isActive ? (
				<Styled.ClockIcon>
					<ClockFilledIcon />
				</Styled.ClockIcon>
			) : (
				<Styled.CalendarIcon $isEnded={isEnded}>
					<CalendarIcon />
				</Styled.CalendarIcon>
			)}
			<Styled.Date $isSmall={isSmall}>{getStartEndDate(start_date, end_date).dateText}</Styled.Date>
		</Styled.Wrapper>
	);
};

export default PromotionDate;
